/**
 * Returns a promise that resolves after the specified time
 * @param time - Time in milliseconds
 */
export default function delay (time : number) {
  return new Promise((resolve) => setTimeout(resolve, time))
}
